var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44195 4.55806C5.19788 4.31398 4.80215 4.31398 4.55807 4.55806C4.31399 4.80214 4.31399 5.19786 4.55807 5.44194L9.11608 9.99996L4.55806 14.558C4.31398 14.8021 4.31398 15.1978 4.55806 15.4419C4.80214 15.6859 5.19786 15.6859 5.44194 15.4419L9.99997 10.8838L14.558 15.4419C14.8021 15.6859 15.1978 15.6859 15.4419 15.4419C15.6859 15.1978 15.6859 14.8021 15.4419 14.558L10.8839 9.99996L15.4419 5.44195C15.6859 5.19787 15.6859 4.80214 15.4419 4.55807C15.1978 4.31399 14.8021 4.31399 14.558 4.55807L9.99997 9.11607L5.44195 4.55806Z",
    fill: "currentColor",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.9eb184b21c2332f8540ba1c0bcc365d2.svg";
export { ForwardRef as ReactComponent };